import { Component, OnInit } from '@angular/core'
import { PatientArchiveService } from '../../../../api/services/patient-archive.service'
import { MessageService } from 'primeng/api'
import { DatePipe } from '@angular/common'
import { environment } from '../../../../../environments/environment'
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms'
import { Router } from '@angular/router'

@Component({
  selector: 'app-restore-patient',
  templateUrl: './restore-patient.component.html',
  styleUrl: './restore-patient.component.css',
})
export class RestorePatientComponent implements OnInit {
  displaypatientRestoreDialog: boolean = true
  patientRestorteConfirmatiomDialog: boolean = false
  patientRestortedSuccessMessage: boolean = false
  restoreBy: string = 'All' // default value
  yearRangeForDatePicker: string
  showrestoreDaterange: boolean = false
  startdate: string = ''
  enddate: string = ''
  archiverestoreForm

  restorehButtonDisabled: boolean = false
  constructor(
    private fb: UntypedFormBuilder,
    private patientarchiveservice: PatientArchiveService,
    private messageService: MessageService,
    private datePipe: DatePipe,
    private router: Router,
  ) {}

  ngOnInit() {
    this.yearRangeForDatePicker = environment.yearRangeForDatePicker

    this.archiverestoreForm = this.fb.group({
      restorebyAll: new UntypedFormControl('all', []),
    })
  }

  restoreconfirmation(event: Event) {
    debugger

    // alert("AAAA")
    this.displaypatientRestoreDialog = false
    this.patientRestorteConfirmatiomDialog = true
  }

  restoreconfirmation2(res: string) {
    // alert("BBBBB");
    if (res == 'ok') {
      this.onRestorePatient(sessionStorage.getItem('ptId'))
      this.patientRestorteConfirmatiomDialog = false
    } else {
      this.patientRestorteConfirmatiomDialog = false
    }
  }
  onRestorePatient(ptId: string): void {
    // alert("CCCCC");
    debugger
    this.patientarchiveservice
      .patientArchiveRestore({
        restoreFlag: 'YES',
        startDate: this.datePipe.transform(this.startdate, 'MM/dd/yyyy'),
        endDate: this.datePipe.transform(this.enddate, 'MM/dd/yyyy'),
        patientArchiveId: -1,
        restoreBy: this.restoreBy,
        patientId: ptId,
      })
      .subscribe((result) => {
        if (result.status.toLowerCase().indexOf('error') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            detail: result.message,
              summary: 'ERROR',
            life: 5000,
          })
        } else if (result.status.toLowerCase().indexOf('ok') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'success',
            detail: 'Restoration queued for nightly process.',
            summary: 'Confirmation',
            life: 6000,
          })

          this.patientRestortedSuccessMessage = true
        }
      })
  }

  ShowhideRestoraion(obj) {
    debugger
    this.restoreBy = obj
    if (obj == 'daterange') {
      this.restorehButtonDisabled = true
      this.showrestoreDaterange = true
    } else {
      this.restorehButtonDisabled = false
      this.showrestoreDaterange = false
      this.startdate = ''
      this.enddate = ''
    }
  }

  goBack(dialogName: string) {
    switch (dialogName.toLowerCase()) {
      case 'displayDialog'.toLowerCase(): {
        //this.patientRestorteConfirmatiomDialog = false;
        this.router.navigate(['Patient', 'dashboard'])
        break
      }

      case 'Confirmation1'.toLowerCase(): {
        this.patientRestorteConfirmatiomDialog = false

        this.displaypatientRestoreDialog = true
        // this.router.navigate(["Patient", "dashboard"])
        break
      }

      case 'Confirmation2'.toLowerCase(): {
        this.router.navigate(['Patient', 'dashboard'])
        break
      }
    }
  }

  checkSearchButtonState() {
    if (this.startdate != '' && this.enddate != '') {
      this.restorehButtonDisabled = false
    } else {
      this.restorehButtonDisabled = true
    }
  }
}
